import React from 'react';
import { NavLink, Outlet, Navigate, useLocation, useSearchParams } from 'react-router-dom';
import {
  SparklesIcon,
  HeartIcon,
  CalendarIcon,
  ClipboardDocumentCheckIcon,
  ChatBubbleLeftRightIcon
} from '@heroicons/react/24/outline';

const tabs = [
  { name: 'Summary', to: 'summary', icon: SparklesIcon },
  { name: 'Prayer', to: 'prayer', icon: HeartIcon },
  { name: 'Attendance', to: 'attendance', icon: ClipboardDocumentCheckIcon },
  { name: 'Events', to: 'events', icon: CalendarIcon },
  { name: 'Chat', to: 'chat', icon: ChatBubbleLeftRightIcon },
];

export default function FeatureAnalyticsLayout() {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // Preserve current filters when navigating between tabs
  const queryString = searchParams.toString();
  const getTabUrl = (path) => queryString ? `${path}?${queryString}` : path;

  // Redirect from /feature-analytics to /feature-analytics/summary (preserving filters)
  if (location.pathname === '/feature-analytics') {
    return <Navigate to={getTabUrl('/feature-analytics/summary')} replace />;
  }

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-deep-navy to-storm-blue text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex items-center gap-3">
            <SparklesIcon className="h-8 w-8" />
            <div>
              <h1 className="text-2xl font-bold">Feature Analytics</h1>
              <p className="text-slate-300 text-sm">
                Feature health, adoption, and usage insights
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="bg-white border-b border-slate-200 sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex gap-1 overflow-x-auto py-2" aria-label="Tabs">
            {tabs.map((tab) => (
              <NavLink
                key={tab.name}
                to={getTabUrl(tab.to)}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                    isActive
                      ? 'bg-flock-blue text-white'
                      : 'text-slate-600 hover:bg-slate-100'
                  }`
                }
              >
                <tab.icon className="h-4 w-4" />
                {tab.name}
              </NavLink>
            ))}
          </nav>
        </div>
      </div>

      {/* Page Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <Outlet />
      </div>
    </div>
  );
}
